import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

// Curated, editor-controlled keywords that link to the global search page.
// Use this on every content type (news/jobs/alerts/insights/tutorials) so
// that an editor can drive cross-content navigation without relying on
// implicit tag matching.
//
// Each chip pre-fetches its result count in one batch call (POST
// /api/keywords/counts) and shows "(N)" inline. Chips with zero matches
// still render — the editor explicitly linked them.
const LinkedKeywords = ({ keywords, lang = "en", testid = "linked-keywords" }) => {
  const [counts, setCounts] = useState({});

  useEffect(() => {
    if (!keywords || keywords.length === 0) return;
    let cancelled = false;
    api
      .post("/keywords/counts", { keywords, language: lang })
      .then((r) => {
        if (!cancelled) setCounts(r.data || {});
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [keywords, lang]);

  if (!keywords || keywords.length === 0) return null;
  const heading = lang === "fr" ? "Mots-clés" : "Keywords";
  return (
    <div data-testid={testid} className="mt-10 pt-6 border-t border-[#E5E7EB]">
      <div className="font-mono-dl text-[10px] tracking-[0.22em] uppercase text-[#00A878] mb-3">
        {heading}
      </div>
      <div className="flex flex-wrap gap-2">
        {keywords.map((kw) => {
          const n = counts[kw];
          return (
            <Link
              key={kw}
              to={`/search?q=${encodeURIComponent(kw)}`}
              data-testid={`linked-keyword-${kw.toLowerCase().replace(/\s+/g, "-")}`}
              className="inline-flex items-center gap-1.5 text-[12px] px-2.5 py-1 bg-white border border-[#111827] text-[#111827] hover:bg-[#111827] hover:text-white transition-colors"
            >
              <span>{kw}</span>
              {typeof n === "number" && (
                <span
                  data-testid={`linked-keyword-count-${kw.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-[10px] font-mono-dl text-[#9ca3af] group-hover:text-white"
                >
                  ({n})
                </span>
              )}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default LinkedKeywords;
